import styles from "./SettingsAppSettingsPage.module.css";
import { useSettingsAppSettingsViewModel } from "@/features/settings/viewModal/useSettingsAppSettingsViewModel";

export const SettingsAppSettingsPage = () => {
  const { deleting, onDeleteAccount } = useSettingsAppSettingsViewModel();

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>
        <span>App </span>
        <span className={styles.titleAccent}>Settings</span>
      </h1>

      <section className={styles.deleteCard}>
        <div className={styles.deleteHeader}>
          <div>
            <h2 className={styles.deleteTitle}>Delete Account</h2>
          </div>
        </div>

        <div className={styles.warningBox}>
          <h3 className={styles.warningTitle}>Important Information</h3>
          <p className={styles.warningText}>
            Account deletion is permanent and cannot be undone. All your data, including:
          </p>
          <ul className={styles.warningList}>
            <li>Profile information</li>
            <li>Chat history</li>
            <li>Settings and preferences</li>
            <li>Associated data</li>
          </ul>
          <p className={styles.warningText}>will be permanently removed from our systems.</p>
        </div>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.deleteButton}
            onClick={onDeleteAccount}
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete Account"}
          </button>
        </div>
      </section>
    </div>
  );
};
